import { ICropping, roundArea } from "../../omnia"

interface EditContext {
    getFormField(name: string): ng.INgModelController,
    useBoundaryArea(): boolean,
    getUsableArea(): number,
    hasCalculatedManureArea(): boolean,
}

export function validateArea(cropping: ICropping, ctxt: EditContext) {

    const ca = validateCroppingArea(cropping, ctxt)
    const ma = validateManureArea(cropping, ctxt)

    return ca && ma

}

function validateCroppingArea(cropping: ICropping, ctxt: EditContext) {

    let ok = true
    const area = cropping.Area

    if (!ctxt.useBoundaryArea()) {

        const maxArea = roundArea(ctxt.getUsableArea())
        ok = ((area > 0) && ((area <= maxArea) || (maxArea <= 0)))

    }

    const mdl = ctxt.getFormField("Area")

    if (mdl) {
        mdl.$setValidity("area", ok)
    }

    return ok

}

export function validateManureArea(cropping: ICropping, ctxt: EditContext) {

    const calc = ctxt.hasCalculatedManureArea()

    const area = calc || checkCroppingManureArea(cropping)
    const field = calc || checkFieldManureArea(cropping)

    const mdl = ctxt.getFormField("ManureSpreadArea")
    if (mdl) {
        mdl.$setValidity("area", area)
        mdl.$setValidity("field", field)
    }

    return area && field

}


function checkCroppingManureArea(cropping: ICropping): boolean {
    return checkManureArea(cropping.ManureSpreadArea, cropping.Area)
}

function checkFieldManureArea(cropping: ICropping): boolean {
    let field = cropping.Field
    if (!field) return true
    return checkManureArea(cropping.ManureSpreadArea, field.ManureSpreadArea);
}

function checkManureArea(value: number, maxArea: number): boolean {

    if ((value == null) || (maxArea == null)) {
        return true
    }

    if (value > maxArea) {
        return false
    }

    return true

}
